export default __webpack_public_path__ + "static/media/layers-1.ef44f60f.svg";